export enum Role {
  ROLE_DIRECTORS = "Directors",
  ROLE_RESOURCE_MANAGEMENT_TEAM = "Resource management team",
  ROLE_RESOURCE_MANAGERS = "Resource Manager",
  ROLE_HR_MANAGERS = "HR Manager",
  ROLE_RECRUITMENT_MANAGER = "Recruitment Manager",
  ROLE_RECRUITMENT_STAFF = "Recruitment staff",
  ROLE_HR_STAFFS = "HR Staff",
  ROLE_EXECUTIVES = "Executives",
  ROLE_ACCOUNTS = "Accounts",
  ROLE_DEMAND_REQUEST = "DemandRequest",
  ROLE_PROJECT_MANAGER = "Project Manager",
  ROLE_RMG = "RMG",
  ROLE_ACCOUNT_STAFF = "Accounts-Staff",
  ROLE_ACCOUNT_SENIOR_MANAGER = "Account Senior Manager",
  ROLE_SUPERVISOR = "Supervisor",
  ROLE_OPS_DASHBOARD_VIEWER = "Ops Dashboard Viewer",
  ROLE_FINANCE = "Finance",
  ROLE_LEADERSHIP_TEAM = "Leadership Team",
  ROLE_DATA_VALIDATOR = "Data Validator"
}

type RequiredRoleFn = (userRoles: Role[], roles: Role[]) => boolean;

export const hasRequiredRole: RequiredRoleFn = (userRoles, roles) =>
  roles.some((role) => userRoles.includes(role));
